import styled from 'styled-components';

import { BaseStyle, Button, Select } from '@nhl/nhl-breakaway-ui';

export const Form = styled.form`
    ${BaseStyle.Mixins.gaps.medium};
    background: ${({ theme }) => theme.Surface.primary};
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    padding-bottom: 20px;
    padding-top: 20px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        flex-direction: row;
    }
`;

export const FilterSelect = styled(Select)`
    flex: 1;

    ${BaseStyle.Mixins.screenSizes.medium} {
        min-width: calc(50% - 8px);
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        min-width: initial;
        max-width: 190px;
    }
`;

export const FilterSubmit = styled(Button)`
    flex: 1;

    ${BaseStyle.Mixins.screenSizes.medium} {
        min-width: calc(50% - 8px);
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        flex: initial;
        min-width: 112px;
        padding: 15px;
    }
`;

// Looks different because it's for ReactSelect
export const selectStyles = {
    control: (base) => ({
        ...base,
        borderColor: '#d2d2d2',
        borderRadius: 0,
        minHeight: 49,
        width: 135,
    }),
};
